// @generated by protoc-gen-es v1.0.0 with parameter "rewrite_imports=./tendermint/version/**/*_pb.js:@buf/tendermint_tendermint.bufbuild_es,rewrite_imports=./tendermint/types/**/*_pb.js:@buf/tendermint_tendermint.bufbuild_es,rewrite_imports=./tendermint/p2p/**/*_pb.js:@buf/tendermint_tendermint.bufbuild_es,rewrite_imports=./tendermint/crypto/**/*_pb.js:@buf/tendermint_tendermint.bufbuild_es,rewrite_imports=./tendermint/abci/**/*_pb.js:@buf/tendermint_tendermint.bufbuild_es,rewrite_imports=./google/api/**/*_pb.js:@buf/googleapis_googleapis.bufbuild_es,rewrite_imports=./gogoproto/**/*_pb.js:@buf/cosmos_gogo-proto.bufbuild_es,rewrite_imports=./cosmos_proto/**/*_pb.js:@buf/cosmos_cosmos-proto.bufbuild_es"
// @generated from file cosmos/bank/v1beta1/tx.proto (package cosmos.bank.v1beta1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { Coin } from "../../base/v1beta1/coin_pb.js";
import { Input, Output, Params, SendEnabled } from "./bank_pb.js";

/**
 * MsgSend represents a message to send coins from one account to another.
 *
 * @generated from message cosmos.bank.v1beta1.MsgSend
 */
export const MsgSend = proto3.makeMessageType(
  "cosmos.bank.v1beta1.MsgSend",
  () => [
    { no: 1, name: "from_address", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "to_address", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "amount", kind: "message", T: Coin, repeated: true },
  ],
);

/**
 * MsgSendResponse defines the Msg/Send response type.
 *
 * @generated from message cosmos.bank.v1beta1.MsgSendResponse
 */
export const MsgSendResponse = proto3.makeMessageType(
  "cosmos.bank.v1beta1.MsgSendResponse",
  [],
);

/**
 * MsgMultiSend represents an arbitrary multi-in, multi-out send message.
 *
 * @generated from message cosmos.bank.v1beta1.MsgMultiSend
 */
export const MsgMultiSend = proto3.makeMessageType(
  "cosmos.bank.v1beta1.MsgMultiSend",
  () => [
    { no: 1, name: "inputs", kind: "message", T: Input, repeated: true },
    { no: 2, name: "outputs", kind: "message", T: Output, repeated: true },
  ],
);

/**
 * MsgMultiSendResponse defines the Msg/MultiSend response type.
 *
 * @generated from message cosmos.bank.v1beta1.MsgMultiSendResponse
 */
export const MsgMultiSendResponse = proto3.makeMessageType(
  "cosmos.bank.v1beta1.MsgMultiSendResponse",
  [],
);

/**
 * MsgUpdateParams is the Msg/UpdateParams request type.
 *
 * Since: cosmos-sdk 0.47
 *
 * @generated from message cosmos.bank.v1beta1.MsgUpdateParams
 */
export const MsgUpdateParams = proto3.makeMessageType(
  "cosmos.bank.v1beta1.MsgUpdateParams",
  () => [
    { no: 1, name: "authority", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "params", kind: "message", T: Params },
  ],
);

/**
 * MsgUpdateParamsResponse defines the response structure for executing a
 * MsgUpdateParams message.
 *
 * Since: cosmos-sdk 0.47
 *
 * @generated from message cosmos.bank.v1beta1.MsgUpdateParamsResponse
 */
export const MsgUpdateParamsResponse = proto3.makeMessageType(
  "cosmos.bank.v1beta1.MsgUpdateParamsResponse",
  [],
);

/**
 * MsgSetSendEnabled is the Msg/SetSendEnabled request type.
 *
 * Only entries to add/update/delete need to be included.
 * Existing SendEnabled entries that are not included in this
 * message are left unchanged.
 *
 * Since: cosmos-sdk 0.47
 *
 * @generated from message cosmos.bank.v1beta1.MsgSetSendEnabled
 */
export const MsgSetSendEnabled = proto3.makeMessageType(
  "cosmos.bank.v1beta1.MsgSetSendEnabled",
  () => [
    { no: 1, name: "authority", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "send_enabled", kind: "message", T: SendEnabled, repeated: true },
    { no: 3, name: "use_default_for", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * MsgSetSendEnabledResponse defines the Msg/SetSendEnabled response type.
 *
 * Since: cosmos-sdk 0.47
 *
 * @generated from message cosmos.bank.v1beta1.MsgSetSendEnabledResponse
 */
export const MsgSetSendEnabledResponse = proto3.makeMessageType(
  "cosmos.bank.v1beta1.MsgSetSendEnabledResponse",
  [],
);

/**
 * MsgBurn defines a message for burning coins.
 *
 * Since: cosmos-sdk 0.51
 *
 * @generated from message cosmos.bank.v1beta1.MsgBurn
 */
export const MsgBurn = proto3.makeMessageType(
  "cosmos.bank.v1beta1.MsgBurn",
  () => [
    { no: 1, name: "from_address", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "amount", kind: "message", T: Coin, repeated: true },
  ],
);

/**
 * MsgBurnResponse defines the Msg/Burn response type.
 *
 * Since: cosmos-sdk 0.51
 *
 * @generated from message cosmos.bank.v1beta1.MsgBurnResponse
 */
export const MsgBurnResponse = proto3.makeMessageType(
  "cosmos.bank.v1beta1.MsgBurnResponse",
  [],
);

